import type { ThemeColors } from "Infrastructure/Themes/Themes";

export const colors = (): ThemeColors => ({
  light: {
    text: {
      primary: "#2C2E30",
      primaryHover: "#FD5203",
      secondary: "#A0A3A6",
      secondaryHover: "#2C2E30",
      tertiary: "#C4C7CA",
      tertiaryHover: "#A0A3A6",
      onbrand: "#FFFFFF",
      disabled: "#C4C7CA",
      inverse: "#FFFFFF",
      light: "#C4C7CA",
      dark: "#FFFFFF",
      brandPrimary: "#FD5203",
      brandPrimaryHover: "#CA3904",
      brandSecondary: "#A02D0C",
      rewardGold: "#FEC800",
      info: "#3B82F6",
      success: "#0AAB2A",
      warning: "#F79009",
      danger: "#EF4444",
    },
    background: {
      primary: "#FFFFFF",
      secondary: "#FAFAFA",
      tertiary: "#F4F5F5",
      inverse: "#1D1F20",
      overlay: "#101A2366",
      hover: "#2337370D",
      selected: "#101A231A",
      disabled: "#0000000A",
      brandPrimary: "#FD5203",
      brandHover: "#CA3904",
      brandSecondary: "#A02D0C",
      brandTertiary: "#FFECD3",
      infoPrimary: "#3B82F6",
      infoHover: "#2563EB",
      infoSecondary: "#293E7A",
      infoTertiary: "#DBEAFE",
      successPrimary: "#0AAB2A",
      successHover: "#0C8926",
      successSecondary: "#0F6C22",
      successTertiary: "#D9FFE0",
      warningPrimary: "#F79009",
      warningHover: "#DC6803",
      warningSecondary: "#B54708",
      warningTertiary: "#FEF0C7",
      dangerPrimary: "#EF4444",
      dangerHover: "#DC2626",
      dangerSecondary: "#B91C1C",
      dangerTertiary: "#FEE4E2",
    },
    border: {
      primary: "#E7E8E9",
      primaryHover: "#D9DBDD",
      secondary: "#1D1F20",
      disabled: "#C4C7CA",
      inverse: "#2C2C2E",
      selected: "#FD5203",
      brand: "#FD5203",
      info: "#3B82F6",
      success: "#0AAB2A",
      warning: "#F79009",
      danger: "#EF4444",
    },
    utility: {
      categoryAdaptation: "#F5D2C6",
      categoryTools: "#E4EEDA",
      categoryBusiness: "#FAE09D",
      categoryLaw: "#CBE2F5",
      categoryMarketing: "#FFBB98",
      categoryPersonalGrowth: "#D4D7FF",
      categoryLeadership: "#F1C0E8",
    },
  },
  dark: {
    text: {
      primary: "#E5E5E6",
      primaryHover: "#FF8C33",
      secondary: "#828387",
      secondaryHover: "#E5E5E6",
      tertiary: "#505053",
      tertiaryHover: "#828387",
      onbrand: "#FFFFFF",
      disabled: "#505053",
      inverse: "#2C2E30",
      light: "#505053",
      dark: "#2C2E30",
      brandPrimary: "#FF6B0C",
      brandPrimaryHover: "#CA3904",
      brandSecondary: "#A02D0C",
      rewardGold: "#FEC800",
      info: "#60A5FA",
      success: "#3EEA60",
      warning: "#FDB022",
      danger: "#F87171",
    },
    background: {
      primary: "#171819",
      secondary: "#C6C6C8",
      tertiary: "#373739",
      inverse: "#FFFFFF",
      overlay: "#05050666",
      hover: "#E8FCFD0D",
      selected: "#F1F1F924",
      disabled: "#FFFFFF0F",
      brandPrimary: "#FD5203",
      brandHover: "#CA3904",
      brandSecondary: "#A02D0C",
      brandTertiary: "#00A49540",
      infoPrimary: "#3B82F6",
      infoHover: "#2563EB",
      infoSecondary: "#93C5FD",
      infoTertiary: "#2563EB40",
      successPrimary: "#0AAB2A",
      successHover: "#0C8926",
      successSecondary: "#7DF895",
      successTertiary: "#3AA16040",
      warningPrimary: "#F79009",
      warningHover: "#DC6803",
      warningSecondary: "#FEC84B",
      warningTertiary: "#DC680326",
      dangerPrimary: "#EF4444",
      dangerHover: "#DC2626",
      dangerSecondary: "#FCA5A5",
      dangerTertiary: "#DC262640",
    },
    border: {
      primary: "#2C2C2E",
      primaryHover: "#373739",
      secondary: "#C6C6C8",
      disabled: "#373739",
      inverse: "#E7E8E9",
      selected: "#CA3904",
      brand: "#FD5203",
      info: "#3B82F6",
      success: "#0AAB2A",
      warning: "#F79009",
      danger: "#EF4444",
    },
    utility: {
      categoryAdaptation: "#F5D2C6",
      categoryTools: "#E4EEDA",
      categoryBusiness: "#FAE09D",
      categoryLaw: "#CBE2F5",
      categoryMarketing: "#FFBB98",
      categoryPersonalGrowth: "#D4D7FF",
      categoryLeadership: "#F1C0E8",
    },
  },
});
